<div class="scanner-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="scanner-header">
      <h2>Buscar restaurante</h2>
    </div>

    <!-- Tab Navigation -->
    <div class="tab-navigation mb-3">
      <div class="nav nav-pills justify-content-center" role="tablist">
        <button
          class="nav-link btn-modern"
          [class.active]="activeTab === 'search'"
          (click)="switchTab('search')"
          type="button"
        >
          <span class="tab-icon">🏪</span>
          <span class="tab-text">Buscar</span>
        </button>
        <button
          class="nav-link btn-modern"
          [class.active]="activeTab === 'scan'"
          (click)="switchTab('scan')"
          type="button"
        >
          <span class="tab-icon">📷</span>
          <span class="tab-text">QR</span>
        </button>
      </div>
    </div>

    <div class="scanner-content">

    <!-- Search Tab -->
    <div *ngIf="activeTab === 'search'" class="search-section">
      <div class="card search-card">
        <div class="card-body">
          <div class="search-form">
            <div class="input-group-modern mb-3">
              <div class="form-floating">
                <input
                  type="text"
                  id="query"
                  [(ngModel)]="searchQuery"
                  class="form-control form-control-lg"
                  placeholder="Ej: Bar Pepe, Pizzeria..."
                  (keyup.enter)="searchByName()"
                >
                <label for="query">Nombre del negocio</label>
              </div>
            </div>

            <button
              type="button"
              class="btn btn-primary search-btn-type w-100"
              [disabled]="searching || !searchQuery || searchQuery.length < 2"
              (click)="searchByName()"
            >
              <span *ngIf="searching" class="spinner-border spinner-border-sm me-2"></span>
              {{ searching ? 'Buscando...' : 'Buscar' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Loading menu after selection -->
      <div *ngIf="processing" class="card mt-4">
        <div class="card-body text-center py-4">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="mb-0">Cargando carta...</p>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="scanError && !processing" class="alert alert-danger mt-3">
        <p class="mb-2">{{ scanError }}</p>
        <button (click)="scanError = null" class="btn btn-outline-danger btn-sm">Cerrar</button>
      </div>

      <!-- Search Results: show businesses -->
      <div *ngIf="searchResults.length > 0 && !processing" class="results-section mt-4">
        <div *ngFor="let restaurant of searchResults"
             class="card mb-3 results-card"
             (click)="selectRestaurant(restaurant)"
             style="cursor: pointer;">
          <div class="card-body d-flex align-items-center gap-3 py-3">
            <div class="restaurant-avatar">
              {{ restaurant.name[0] }}
            </div>
            <div class="flex-grow-1">
              <h6 class="mb-1 fw-bold">{{ restaurant.name }}</h6>
              <small class="text-muted">
                {{ restaurant.menus?.length || 0 }} carta{{ restaurant.menus?.length !== 1 ? 's' : '' }} disponible{{ restaurant.menus?.length !== 1 ? 's' : '' }}
              </small>
            </div>
            <div class="select-arrow">&rsaquo;</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Scan Tab -->
    <div *ngIf="activeTab === 'scan'">
      <div class="card scanner-area">
        <div *ngIf="!hasPermission" class="permission-message">
          <div class="message-content">
            <h3>Permiso de camara requerido</h3>
            <p>Para usar el escaner QR, necesitas permitir el acceso a la camara.</p>
            <button (click)="requestCameraPermission()" class="btn btn-primary btn-lg">
              Solicitar permiso
            </button>
          </div>
        </div>

        <div *ngIf="hasPermission && !hasDevices" class="no-devices-message">
          <div class="message-content">
            <h3>No se encontraron camaras</h3>
            <p>No se detectaron camaras en tu dispositivo.</p>
          </div>
        </div>

        <div *ngIf="hasPermission && hasDevices" class="scanner-wrapper">
          <zxing-scanner
            #scanner
            [device]="currentDevice"
            [formats]="allowedFormats"
            (scanSuccess)="onCodeResult($event)"
            (scanError)="onScanError($event)"
            (hasPermission)="onHasPermission($any($event))"
            (camerasFound)="onCamerasFound($event)"
            class="qr-scanner"
          ></zxing-scanner>

          <div class="scanner-overlay">
            <div class="scan-frame"></div>
            <p class="scan-instruction">Apunta la camara hacia un codigo QR</p>
          </div>
        </div>
      </div>

      <!-- Camera Selection -->
      <div *ngIf="hasDevices && availableDevices.length > 1" class="card camera-selection mt-3">
        <div class="form-group p-3">
          <label for="camera-select">Seleccionar camara:</label>
          <select
            id="camera-select"
            (change)="onDeviceSelectChange($any($event.target).value)"
            class="form-control"
          >
            <option
              *ngFor="let device of availableDevices"
              [value]="device.deviceId"
              [selected]="device.deviceId === currentDevice?.deviceId"
            >
              {{ device.label || 'Camara ' + (availableDevices.indexOf(device) + 1) }}
            </option>
          </select>
        </div>
      </div>

      <!-- Processing QR -->
      <div *ngIf="processing" class="card mt-3">
        <div class="card-body text-center">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p>Procesando codigo QR...</p>
        </div>
      </div>

      <!-- QR Error -->
      <div *ngIf="scanError" class="alert alert-danger mt-3">
        <p>{{ scanError }}</p>
        <button (click)="clearResults()" class="btn btn-outline-danger btn-sm">Reintentar</button>
      </div>

      <!-- QR Result: Restaurant & Menu -->
      <div *ngIf="restaurantData && menuData && !processing" class="card restaurant-section mt-3">
        <div class="card-header">
          <div class="result-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ restaurantData.name }}</h5>
            <button (click)="clearResults()" class="btn btn-outline-secondary btn-sm">Limpiar</button>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="menuData.categories && menuData.categories.length > 0" class="mb-3">
            <div *ngFor="let category of menuData.categories.slice(0, 3)" class="mb-1">
              <strong>{{ category.name }}</strong>
              <span class="badge bg-light text-dark ms-2">{{ category.items?.length || 0 }} platos</span>
            </div>
            <div *ngIf="menuData.categories.length > 3" class="text-muted">
              ... y {{ menuData.categories.length - 3 }} categorias mas
            </div>
          </div>
          <button (click)="viewMenu()" class="btn btn-success btn-lg w-100">
            Ver Carta Completa
          </button>
        </div>
      </div>
    </div>

    </div> <!-- scanner-content -->
  </div>
</div>
